import { combineReducers } from 'redux';
import * as actions from '~/actions/orgFeatureFlag';

const orgFeatureFlag = () => {
  const featureFlagData = (state = [], action) => {
    switch (action.type) {
      case actions.UPDATE_ORG_FEATURES_SUCCESS:
        return action.features;
      default:
        return state;
    }
  };

  const isFetching = (state = {}, action) => {
    switch (action.type) {
      case actions.UPDATE_ORG_FEATURES_REQUEST:
        return true;
      case actions.UPDATE_ORG_FEATURES_SUCCESS:
      case actions.UPDATE_ORG_FEATURES_FAILURE:
        return false;
      default:
        return state;
    }
  };

  const errorMessage = (state = {}, action) => {
    switch (action.type) {
      case actions.UPDATE_ORG_FEATURES_FAILURE:
        return action.message;
      case actions.UPDATE_ORG_FEATURES_REQUEST:
      case actions.UPDATE_ORG_FEATURES_SUCCESS:
        return null;
      default:
        return state;
    }
  };

  return combineReducers({
    featureFlagData,
    isFetching,
    errorMessage,
  });
};

export default orgFeatureFlag();
